import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
// import Select from 'react-select';
import PropTypes from 'prop-types';
// import { reactSelectCustomStyleBigger } from 'modules/common/components/Select';

import _ from 'lodash';
import CalendarComponent from '../components/CalendarComponent';
import Information from '../components/Information';

import 'react-big-calendar/lib/css/react-big-calendar.css';

import * as actions from '../action';
import * as c from '../constant';
import CreateCalendarEntryModal from '../components/CreateCalendarEntryModal';

function CalendarEntriesContainer({
  calendarEntryList,
  getCalendarEntriesList,
  showCalendarEntry,
  calendarEntryInfo,
}) {
  const setModal = useContext(ModalContext);
  // const [transaction, setTransaction] = useState('');

  // const setStatusFilter = (e) => {
  //   setTransaction(e);
  // };

  // const statusOption = [{ label: 'Occupational & Health', value: 5 }];

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateCalendarEntryModal />,
      title: 'Add Calendar Entry',
      modalSize: 'modal-md',
    });
  };

  useEffect(() => {
    getCalendarEntriesList({
      order: 'ASC',
    });
    return () => {};
  }, []);

  const onSelectEvent = (data) => {
    showCalendarEntry(data.id);
  };

  /* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */
  const formatEvents = (data) => {
    const newArr = [];
    for (let i = 0; i < Object.keys(data).length; i++) {
      if (data[i]) {
        const attrib = data[i].attributes;
        newArr.push({
          id: data[i].id,
          title: attrib.title,
          start: attrib.date,
          end: attrib.date,
          type: attrib.type,
          description: attrib.description,
        });
      }
    }
    return newArr;
  };

  return (
    <div className="container-fluid card-section-content">
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          <span className="full-label">Calendar Entries</span>
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
          >
            Add&nbsp;
            <i className="fas fa-plus" />
          </button>
        </div>
      </div>

      <div className="w-100">
        <div className="row">
          <div className="col-md-8">
            <div className="card">
              {/* <div className="row p2">
                <div className="col-md-12">
                  <div className="d-flex align-items-right mt-3 mr-1">
                    <div className="d-flex align-items-center ml-auto">
                      <div>
                        <label className="form-label mt-2 ml-auto mb-0">
                          <span className="text-muted">
                            <h4>Transaction:</h4>
                          </span>
                        </label>
                      </div>
                      <Select
                        styles={reactSelectCustomStyleBigger}
                        value={transaction}
                        onChange={setStatusFilter}
                        options={statusOption}
                      />
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="row">
                <div className="col-md-12">
                  <CalendarComponent
                    data={
                      calendarEntryList.length !== 0
                        ? formatEvents(calendarEntryList)
                        : []
                    }
                    onSelectEvent={onSelectEvent}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-4">
            <Information data={calendarEntryInfo} />
          </div>
        </div>
      </div>
    </div>
  );
}

CalendarEntriesContainer.propTypes = {
  calendarEntryList: PropTypes.instanceOf(Object).isRequired,
  calendarEntryInfo: PropTypes.instanceOf(Object).isRequired,
  getCalendarEntriesList: PropTypes.instanceOf(Function).isRequired,
  showCalendarEntry: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  calendarEntryList: _.get(api, `${c.GET_CALENDAR_ENTRIES_LIST}.list`) || [],
  calendarEntryInfo: _.get(api, `${c.SHOW_CALENDAR_ENTRIES}.res.data`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(CalendarEntriesContainer);
